import React from 'react';
import {
  BookOpenIcon,
  CalendarDaysIcon,
  UserGroupIcon,
  Squares2X2Icon,
  DocumentPlusIcon,
  ChatBubbleBottomCenterTextIcon,
  MapPinIcon,
  EnvelopeIcon,
  GlobeAltIcon,
  MagnifyingGlassIcon,
  CheckCircleIcon as HeroCheckCircleIcon
} from '@heroicons/react/24/outline';

export const BookIcon = ({ className = "w-6 h-6", ...props }) => (
  <BookOpenIcon className={className} aria-hidden="true" {...props} />
);

export const CalendarIcon = ({ className = "w-6 h-6", ...props }) => (
  <CalendarDaysIcon className={className} aria-hidden="true" {...props} />
);

export const UsersIcon = ({ className = "w-6 h-6", ...props }) => (
  <UserGroupIcon className={className} aria-hidden="true" {...props} />
);

export const ClubsIcon = ({ className = "w-6 h-6", ...props }) => (
  <Squares2X2Icon className={className} aria-hidden="true" {...props} />
);

export const DocumentAddIcon = ({ className = "w-6 h-6", ...props }) => (
  <DocumentPlusIcon className={className} aria-hidden="true" {...props} />
);

export const QuoteIcon = ({ className = "w-7 h-7", ...props }) => (
  <ChatBubbleBottomCenterTextIcon className={className} aria-hidden="true" {...props} />
);

export const LocationIcon = ({ className = "w-4 h-4 inline-block", ...props }) => (
  <MapPinIcon className={className} aria-hidden="true" {...props} />
);

export const MailIcon = ({ className = "w-4 h-4 inline-block", ...props }) => (
  <EnvelopeIcon className={className} aria-hidden="true" {...props} />
);

export const GlobeIcon = ({ className = "w-4 h-4 inline-block", ...props }) => (
  <GlobeAltIcon className={className} aria-hidden="true" {...props} />
);

export const SearchIcon = ({ className = "w-5 h-5", ...props }) => (
  <MagnifyingGlassIcon className={className} aria-hidden="true" {...props} />
);

export const CheckCircleIcon = ({ className = "w-5 h-5", ...props }) => (
  <HeroCheckCircleIcon className={className} aria-hidden="true" {...props} />
);
